// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui' //New Added
import 'element-ui/lib/theme-chalk/index.css' //New Added
import axios from 'axios'
import Qs from 'qs'
import Bus from '../src/components/common/bus'
import global from "@/global/global.js"

// 配置响应拦截器
axios.interceptors.response.use(function (response) {
  // 正常响应处理
  return response
}, function (error) {
  // 非正常响应处理(包括401)
  // console.dir(error) // 对象： config request response isAxiosError toJSON
  if (error.response.status === 401) {
    // token失效(token在服务器端已经失效了，2个小时时效)
    // 强制用户重新登录系统，以刷新服务器端的token时效
    router.push('/')
    // 不要给做错误提示了
    return new Promise(function () {}) // 空的Promise对象，没有机会执行catch，进而不做错误提示了
  }
  return Promise.reject(error)
})

Vue.config.productionTip = false
Vue.use(ElementUI) //New Added
Vue.prototype.$axios = axios
axios.defaults.baseURL = 'http://shlj.lijiantek.com:9010'
// axios.defaults.baseURL = 'http://localhost:9010'
Vue.prototype.$qs = Qs 
Vue.prototype.$bus = Bus 
Vue.prototype.global = global

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js